/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */
import {
    InvoiceListingResolver,
    EstimateListingResolver,
    CreditnoteListingResolver,
    OrderListingResolver,
    DeliveryListingResolver,
    ProformaListingResolver,
    InvoiceDraftListingResolver,
    CreditnotedraftListingResolver,
} from 'api/routing/listings/SalesListingRoutingResolver';
import ListingsWrapper from 'vcomponents/listing/ListingsWrapper.vue';
import Listing from 'vcomponents/listing/Listing.vue';
import EnableConformity from 'vcomponents/settings/sellsymodule/invoicing/EnableConformity.vue';

export default [
    {
        path: '/sales',
        name: 'sales',
        component: ListingsWrapper,
        props: {
            group: 'sales',
        },
        children: [
            {
                path: 'invoice',
                name: 'invoice',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new InvoiceListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'estimate',
                name: 'estimate',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new EstimateListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'creditnote',
                name: 'creditnote',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new CreditnoteListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'proforma',
                name: 'proforma',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new ProformaListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
        ],
    },
    {
        path: '/sales',
        name: 'drafts',
        component: ListingsWrapper,
        props: {
            group: 'drafts',
        },
        children: [
            {
                path: 'invoice/draft',
                name: 'invoicedraft',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new InvoiceDraftListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'creditnote/draft',
                name: 'creditnotedraft',
                component: Listing,
                meta: {
                    menuId: 'invoicing',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new CreditnotedraftListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
        ],
    },
    {
        path: '/sales/order',
        name: 'order',
        component: Listing,
        meta: {
            title: window.i18n.__('Bons de commande'),
            menuId: 'invoicing',
        },
        beforeEnter: (to, from, next) => {
            const listingResolver = new OrderListingResolver();
            listingResolver.feed(to);
            next();
        },
        props: true,
    },
    {
        path: '/sales/delivery',
        name: 'delivery',
        component: Listing,
        meta: {
            title: window.i18n.__('Bons de livraison'),
            menuId: 'invoicing',
        },
        beforeEnter: (to, from, next) => {
            const listingResolver = new DeliveryListingResolver();
            listingResolver.feed(to);
            next();
        },
        props: true,
    },
    {
        path: '/?_f=invoiceOverview&id={id}',
        name: 'invoicing.invoice.overview',
    },
    {
        path: '/?_f=estimateOverview&id={id}',
        name: 'invoicing.estimate.overview',
    },
    {
        path: '/?_f=creditnoteOverview&id={id}',
        name: 'invoicing.creditnote.overview',
    },
    {
        path: '/?_f=deliveryOverview&id={id}',
        name: 'invoicing.delivery.overview',
    },
    {
        path: '/?_f=proformaOverview&id={id}',
        name: 'invoicing.proforma.overview',
    },
    {
        path: '/?_f=orderOverview&id={id}',
        name: 'invoicing.order.overview',
    },
    {
        path: '/accounts/conformities',
        name: 'invoicing.account.conformities',
    },
    {
        path: '/rest/estimate/:id/:type',
        name: 'legacy.estimate.save',
    },
    {
        path: '/rest/invoice/:id/:type',
        name: 'legacy.invoice.save',
    },
    {
        path: '/rest/creditnote/:id/:type',
        name: 'legacy.creditnote.save',
    },
    {
        path: '/rest/delivery/:id/:type',
        name: 'legacy.delivery.save',
    },
    {
        path: '/rest/order/:id/:type',
        name: 'legacy.order.save',
    },
    {
        path: '/rest/model/:id/:type',
        name: 'legacy.model.save',
    },
    {
        path: '/rest/proforma/:id/:type',
        name: 'legacy.proforma.save',
    },
    {
        path: '/documents/preferences/conformity/enable',
        name: 'invoicing.conformity.enable',
        component: EnableConformity,
    },
    {
        path: '/sales/:queryDocType/:queryDocId/progress-invoice-form',
        name: 'progress-invoice-form',
        component: () => import('vcomponents/pages/invoice/ProgressInvoiceFormPage.vue'),
        props: true,
    },
];
